import { JobAssignCrewControls } from '@/components/jobs/job-assign-crew-controls'
import type { Assignment } from '@/types'

type JobAssignCrewPanelProps = {
  jobId: string | number
  serviceInstanceId?: string | null
  assignments: Assignment[]
  disabled?: boolean
}

export function JobAssignCrewPanel({
  jobId,
  serviceInstanceId,
  assignments,
  disabled = false,
}: JobAssignCrewPanelProps) {
  return (
    <JobAssignCrewControls
      jobId={jobId}
      assignments={assignments}
      serviceInstanceId={serviceInstanceId}
      disabled={disabled}
      variant="panel"
    />
  )
}

export default JobAssignCrewPanel
